<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<div *ngIf="!loading" class="max-w-[624px] mx-auto mt-4">
    <form [formGroup]="procedureForm" (ngSubmit)="onSubmit()">
        
        <!-- HEADER -->
        <div class="border-b pb-4">
            <p class="font-medium text-base text-westetics-neutral-950">
                Informações do Procedimento
            </p>
            <p class="text-sm text-westetics-neutral-800 mt-2">
                Preencha as informações do procedimento
            </p>
        </div>

        <!-- Nome do Procedimento -->
        <div class="border-b pb-4 mt-4">
            <label for="description" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                Nome do Procedimento* 
                <span class="text-xs font-normal text-westetics-neutral-600">({{ charRemaining }} caracteres restantes)</span>
            </label>
            <input
                type="text"
                id="description"
                formControlName="description"
                placeholder="Insira o nome do procedimento"
                maxlength="250"
                (keydown)="onKeydown($event)"
                class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                [ngClass]="{'border-red-500': procedureForm.get('description')?.invalid && procedureForm.get('description')?.touched}"
            />
            <span class="text-xs text-westetics-neutral-600 mt-1">Não é permitido o uso de vírgulas</span>
            <span class="text-red-600 text-sm block" *ngIf="procedureForm.get('description')?.invalid && procedureForm.get('description')?.touched">
                Insira um nome de procedimento válido.
            </span>
        </div>

        <!-- Valor e Método de Pagamento -->
        <div class="border-b pb-4 mt-4 grid grid-cols-2 gap-4">
            <!-- Valor -->
            <div>
                <label for="value" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                    Valor do Procedimento*
                </label>
                <input
                    type="text"
                    id="value"
                    formControlName="value"
                    placeholder="0,00"
                    (input)="onValueInput($event)"
                    (blur)="onValueBlur($event)"
                    class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                    [ngClass]="{'border-red-500': procedureForm.get('value')?.invalid && procedureForm.get('value')?.touched}"
                />
                <span class="text-red-600 text-sm block" *ngIf="procedureForm.get('value')?.invalid && procedureForm.get('value')?.touched">
                    Insira um valor válido.
                </span>
            </div>

            <!-- Método de Pagamento -->
            <div>
                <label for="paymentMethod" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                    Método de Pagamento
                </label>
                <input
                    type="text"
                    id="paymentMethod"
                    formControlName="paymentMethod"
                    placeholder="Insira o método de pagamento"
                    class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                />
            </div>
        </div>

        <!-- Botões (responsivo: empilha em mobile/tablet, centralizados em desktop) -->
        <div class="flex flex-col md:flex-row md:justify-center items-center gap-3 my-6">
            <button
                type="button"
                (click)="onCancel()"
                class="w-full md:w-44 px-4 py-2 md:py-[10px] text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 rounded-lg border text-sm md:text-base"
            >
                Cancelar
            </button>
            <button
                type="submit"
                class="w-full md:w-44 px-4 py-2 md:py-[10px] bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg text-sm md:text-base"
            >
                Cadastrar
            </button>
        </div>
    </form>
</div>
